<template>
    <div>
        <b-table :empty-text="this.$t('there_are_no_records')" bordered striped responsive :items="dailyAttendances"
            :fields="dailyAttendancesFields" show-empty class="mb-5 table-dropdown no-scrollbar border rounded">
        </b-table>
    </div>
</template>
<script>

import moment from "moment";

export default {
    name: "AttendanceDetailTable",
    props: {
        dailyAttendanceList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dailyAttendances: [],
            dailyAttendancesFields: [
                {
                    key: 'date',
                    label: this.$t('date'),
                    tdClass: 'w-50 text-center',
                    thClass: 'd-flex justify-content-center align-center',
                },
                {
                    key: 'hours',
                    label: this.$t('attendance_hours'),
                    tdClass: 'w-50 text-center',
                    thClass: 'text-center'
                },

            ]
        }
    },
    watch: {
        dailyAttendanceList: {
            handler(value) {
                this.setData(value)
            }
        }
    },
    methods: {
        setData(value) {
            this.dailyAttendances = value
            this.dailyAttendances.forEach((itm, index) => {
                this.dailyAttendances[index].date = moment(itm.date,'YYYY-MM-DD').format('DD-MM-YYYY')
            })
        }
    }
}
</script>

